// core/selection/HiddenStateSync.ts
/**
 * Синхронизация выбранных ID и текущей строки в hidden-инпуты,
 * совместимые с легаси-сервером: _tpk_<tableKey>__checkedRows / __currentRow
 */
class HiddenStateSync {
    constructor(root, tableKey, debounceMs = 150) {
        this.root = root;
        this.tableKey = tableKey;
        this.debounceMs = debounceMs;
    }
    /**
     * @param silent 2026-08-16. Обновить значения без события change:
     *               подписчики (asidereload) не должны реагировать на cell-selection
     */
    write(selectedIds, currentId, silent = false) {
        const doWrite = () => {
            // checkedRows
            const checked = this.root.querySelector(`input[data-key="_tpk_${this.tableKey}__checkedRows"]`);
            if (checked) {
                checked.value = selectedIds.join(',');
                if (!silent)
                    checked.dispatchEvent(new Event('change', { bubbles: true }));
            }
            // currentRow
            const current = this.root.querySelector(`input[data-key="_tpk_${this.tableKey}__currentRow"]`);
            if (current) {
                current.value = currentId ?? '';
                if (!silent)
                    current.dispatchEvent(new Event('change', { bubbles: true }));
            }
        };
        if (this.debounceMs <= 0)
            return doWrite();
        if (this.t)
            window.clearTimeout(this.t);
        this.t = window.setTimeout(doWrite, this.debounceMs);
    }
    dispose() {
        if (this.t) {
            clearTimeout(this.t);
            this.t = undefined;
        }
    }
}

export { HiddenStateSync };
